import React from 'react';

function AboutWhatDrivesUsSection() {
  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      padding: '64px clamp(24px, 12.5vw, 240px)',
      boxSizing: 'border-box',
      background: '#FFFFFF',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 48,
      flexWrap: 'wrap'
    },
    leftCol: {
      flex: '1 1 0',
      minWidth: 260,
      maxWidth: 520,
      textAlign: 'left'
    },
    overline: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 20,
      lineHeight: '100%',
      letterSpacing: '-0.01em',
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    overlineRule: {
      display: 'inline-block',
      width: 150,
      height: 0,
      borderBottom: '2px solid #E73123',
      marginLeft: 12,
      verticalAlign: 'middle',
      opacity: 1
    },
    titleRed: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '100%',
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#E73123',
      margin: '8px 0 0 0'
    },
    titleBlack: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '100%',
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    body: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '28px',
      letterSpacing: 0,
      color: '#838383',
      margin: '16px 0 0 0'
    },
    list: {
      listStyle: 'none',
      padding: 0,
      margin: '20px 0 0 0'
    },
    listItem: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '28px',
      color: '#090909',
      marginBottom: 12,
      paddingLeft: 28,
      position: 'relative'
    },
    checkmark: {
      position: 'absolute',
      left: 0,
      top: 4,
      color: '#E73123',
      fontSize: 18,
      fontWeight: 700
    },
    rightCol: {
      flex: '0 0 520px',
      width: 520,
      maxWidth: '100%',
      minWidth: 0
    },
    image: {
      width: '100%',
      maxWidth: 520,
      aspectRatio: '4/3',
      objectFit: 'cover',
      display: 'block',
      opacity: 1
    }
  };

  var listItems = [
    'We are driven by innovation, expert engineering,',
    'Highly trained engineers and state-of-the-art machinery',
    'Expanding our footprint globally, responsibly',
    "Building infrastructure for a brighter future, including India's high-speed rail network"
  ];

  return React.createElement('section', { style: styles.section },
    React.createElement('div', { style: styles.leftCol },
      React.createElement('h2', { style: styles.overline },
        'WHAT DRIVES US',
        React.createElement('span', { style: styles.overlineRule })
      ),
      React.createElement('h3', { style: { margin: '8px 0 0 0', textAlign: 'left' } },
        React.createElement('span', { style: styles.titleRed }, 'INNOVATION, '),
        React.createElement('span', { style: styles.titleBlack }, 'EXPERTISE, AND A VISION FOR GLOBAL PROGRESS')
      ),
      React.createElement('p', { style: styles.body },
        'We are driven by innovation, expert engineering, and advanced technology to solve complex challenges and build infrastructure that shapes the future.'
      ),
      React.createElement('ul', { style: styles.list },
        listItems.map(function (item, i) {
          return React.createElement('li', { key: i, style: styles.listItem },
            React.createElement('span', { style: styles.checkmark }, '\u2713'),
            item
          );
        })
      )
    ),
    React.createElement('div', { style: styles.rightCol },
      React.createElement('img', {
        src: '/drivesus.jpg',
        alt: 'Infrastructure - What drives us',
        style: styles.image
      })
    )
  );
}

export default AboutWhatDrivesUsSection;
